import { gql } from '@apollo/client';

export const GET_DOCUMENTS = gql`
  query Documents {
    documents {
      id
      document
      name
      hasViewed
    }
  }
`;

export const GET_DOCUMENTS_HAS_VIEWED = gql`
  query DocumentsView {
    documents {
      id
      hasViewed
    }
  }
`;

export const GET_FAQ = gql`
  query FAQ($section: String) {
    faq(section: $section) {
      id
      question
      answer
      section
      linkLabel
      link
      documentName
      document
    }
  }
`;
